<template>
  <div class="global-content-box global-content-flex">
    <y-menu-title />
    <!-- 顶部搜索区域 -->
    <div class="global-mb16">
      <y-form :formInfo="formInfo" @search="search" @selfReset="reset">
        <template #platform>
          <y-shop-by-platform
            ref="yShopByPlatformRef"
            :shopData="shopData"
            @change="shopChange"
          ></y-shop-by-platform>
        </template>
      </y-form>
    </div>
    <!-- 操作按钮栏 -->
    <el-tabs v-model="formDataList.updateType" @tab-click="switchTab">
      <el-tab-pane label="发放" name="0"></el-tab-pane>
      <el-tab-pane label="过期" name="1"></el-tab-pane>
      <el-tab-pane label="作废" name="2"></el-tab-pane>
    </el-tabs>
    <!-- 活动列表 -->
    <div class="global-felx-1">
      <y-table
        :tableData="tableData"
        tooltip-effect="dark"
        :loading="talbeLoading"
        :tableInfo="tableInfo"
        :pageInfo="{
          pageNum: formDataList.pageNum,
          pageSize: formDataList.pageSize,
          total: total,
        }"
        @handlePage="handlePage"
      >
        <template #platform="scope">
          <span> {{ $getPlatformNameByValue(scope.row.platform) }} </span>
        </template>
      </y-table>
    </div>
  </div>
</template>

<script>
import { getGrowValueChangeRecord } from "@/api/memberMessageSystem";
import { isScoresBindList } from "@/api/integralCenter/newMemberSystem";
export default {
  name: "growthRecord",
  components: {},
  data() {
    return {
      total: 0,
      formDataList: {
        channelSellerId: null, // 全渠道会员ID
        memberId: null, //会员ID
        changeSource: "", // 变更来源
        // 成长变更值
        changeValStart: "", //范围值1
        changeValEnd: "", //范围值2
        // 变更时间
        startTime: "", //首次入会时间-开始
        endTime: "", //首次入会时间-截止
        // 变更类型
        updateType: "0",
        // 页码
        pageSize: 10,
        pageNum: 1,
        platform: "",
        sellerManageId: "",
      },
      // 变更来源
      scoresFromList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "手工调整",
        },
        {
          value: 1,
          label: "成长值过期",
        },
        {
          value: 2,
          label: "订单赠送",
        },
        {
          value: 3,
          label: "退单扣减",
        },
      ],
      talbeLoading: false,
      tableData: [],

      formInfo: [
        {
          prop: "platform",
          label: "平台名称：",
          slot: "platform",
        },
        {
          label: "全渠道会员ID：",
          prop: "memberId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "变更来源：",
          prop: "changeSource",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "全部",
            },
            {
              value: 0,
              label: "手工调整",
            },
            {
              value: 1,
              label: "成长值过期",
            },
            {
              value: 2,
              label: "订单赠送",
            },
            {
              value: 3,
              label: "退单扣减",
            },
          ],
        },
        {
          label: "成长变更值：",
          startKey: "changeValStart",
          endKey: "changeValEnd",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
        },
        {
          label: "变更时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "changeTimeStart",
          endKey: "changeTimeEnd",
        },
      ],
      tableInfo: [
        {
          prop: "memberId",
          label: "全渠道会员ID",
          width: "150px",
        },
        {
          prop: "platform",
          label: "平台",
          slot: "platform",
        },
        {
          prop: "sellerManageName",
          label: "店铺名称",
        },
        {
          prop: "scoresGrowRecordId",
          label: "变更流水号",
          showOverflowTooltip: true,
        },
        {
          prop: "scoresCount",
          label: "变更值",
          align: "right",
        },
        {
          prop: "scoresType",
          label: "变更类型",
          formatter: (row) => {
            if (row.scoresType == 0) {
              return "发放";
            } else if (row.scoresType == 1) {
              return "作废";
            } else if (row.scoresType == 2) {
              return "过期";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "expiryDate",
          label: "成长值到期时间",
        },
        {
          prop: "changeSource",
          label: "变更来源",
          width: "230px",
          formatter: (row) => {
            if (row.changeSource == 0) {
              return "手工调整";
            } else if (row.changeSource == 1) {
              return "成长值过期";
            } else if (row.changeSource == 2) {
              return "订单赠送";
            } else if (row.changeSource == 3) {
              return "退单扣减";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "remark",
          label: "备注",
          showOverflowTooltip: true,
        },
        {
          prop: "createTime",
          label: "变更时间",
          width: "180px",
        },
        {
          prop: "remainCount",
          label: "变更后成长值",
          align: "right",
        },
      ],
      shopData: [],
    };
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "会员信息管理", "成长值变更记录");
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log(this.MemberSystemInfo, "11");
  },
  mounted() {
    // 获取成长值列表
    this.getActivityList();
    this.getScoresBindList();
  },
  methods: {
    shopChange(platform, shop) {
      this.formDataList.platform = platform;
      this.formDataList.sellerManageId = shop;
    },
    search(obj) {
      for (const key in obj) {
        if (key != "platform") {
          this.formDataList[key] = obj[key];
        }
      }
      this.formDataList.pageNum = 1;
      this.formDataList.pageSize = 10;
      this.getActivityList();
    },
    reset() {
      this.$refs.yShopByPlatformRef.reset();
    },
    switchTab(tab) {
      this.formDataList.updateType = tab.name;
      this.formDataList.pageNum = 1;
      this.formDataList.pageSize = 10;
      this.getActivityList();
    },
    // 获取店铺列表
    getScoresBindList() {
      let _param = {
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        pageNum: 1,
        pageSize: 99,
      };
      isScoresBindList(_param).then((res) => {
        if (res.code == 200) {
          this.shopData = res.data.dataList.map((item) => {
            return {
              label: item.shopTitle,
              value: item.channelSellerManageId,
              platform: item.platform,
            };
          });
        }
      });
    },
    // 获取活动列表
    getActivityList() {
      this.talbeLoading = true;
      getGrowValueChangeRecord({
        ...this.formDataList,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
      })
        .then((res) => {
          this.talbeLoading = false;
          if (res.code == 200) {
            this.tableData = res.data.dataList;
            this.total = res.data.pageInfo.total;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {});
    },
    handlePage(page) {
      this.formDataList.pageNum = page.pageNum;
      this.formDataList.pageSize = page.pageSize;
      this.getActivityList();
    },
    // 分页
    handleSizeChange(val) {
      this.formDataList.pageSize = val;
      this.getActivityList();
    },
    handleCurrentChange(val) {
      this.formDataList.pageNum = val;
      this.getActivityList();
    },
    // 重置
    getClean() {
      this.formDataList = {
        channelSellerId: null, // 全渠道会员ID
        memberId: null, //会员ID
        changeSource: "", // 变更来源
        // 成长变更值
        changeValStart: "", //范围值1
        changeValEnd: "", //范围值2
        // 变更时间
        startTime: "", //首次入会时间-开始
        endTime: "", //首次入会时间-截止
        // 变更类型
        updateType: "0",
        // 页码
        pageSize: 10,
        pageNum: 1,
      };
      this.getActivityList();
    },
  },
};
</script>